// ----- Phase 5.X-submission-reorder — Drag handle ----- //
//
// The ↕ glyph rendered at the left edge of every draggable row in the
// ReorderModal. Pure presentational — the parent attaches the HTML5
// `draggable` + dnd event handlers to the surrounding row itself, not
// to this handle.
//
// Why a separate component: keeping the handle isolated lets the
// modal's row click-handler stay drag-free (V1's UI cued drag with the
// glyph but didn't restrict drag to it — the whole row is the drop
// target).

import type { ReactElement } from 'react';

export interface ReorderRowDragHandleProps {
  /**
   * Locked rows still render the glyph but with reduced contrast +
   * `aria-disabled` so the visual affordance matches the actual UX:
   * the row is in the list but cannot be moved.
   */
  readonly disabled?: boolean;
}

export function ReorderRowDragHandle({
  disabled = false,
}: ReorderRowDragHandleProps): ReactElement {
  return (
    <span
      aria-hidden="true"
      data-testid="reorder-drag-handle"
      aria-disabled={disabled ? 'true' : undefined}
      style={{
        display: 'inline-block',
        width: 18,
        textAlign: 'center',
        cursor: disabled ? 'not-allowed' : 'grab',
        color: disabled ? 'var(--border)' : 'var(--text-muted)',
        userSelect: 'none',
        fontSize: 14,
        lineHeight: 1,
      }}
    >
      ↕
    </span>
  );
}
